import { History } from 'history';

import { routerActions } from '../state';

export const routerMiddleware = (params: { history: History }) => () => next => action => {
  switch (action.type) {
    case routerActions.push.actionType:
      params.history.push(action.payload);
      // No return, no next() here
      // We stop all history events from progressing further through the dispatch chain...
      break;
    case routerActions.replace.actionType:
      params.history.replace(action.payload);
      break;
    case routerActions.go.actionType:
      params.history.go(action.payload);
      break;
    case routerActions.goBack.actionType:
      params.history.goBack();
      break;
    case routerActions.goForward.actionType:
      params.history.goForward();
      break;
    default:
      // ...but we want to leave all events we don't care about undisturbed
      return next(action);
  }
};
